import JobPreviewView from './job_preview_view';

const JobPreview = JobPreviewView;
export default JobPreview;
